import React from 'react';

import { FormikProps, useField } from 'formik';

import Datepicker from '../datepicker/Datepicker';
import FormItem from './FormItem';

const FormCalendar: React.FC<
  React.ComponentProps<typeof Datepicker> & {
    formItemProps?: any;
    label: string;
    name: string;
    readonly?: boolean;
    onChange?: (e: any) => void;
    onBlur?: (e: any) => void;
    form?: FormikProps<any>;
    labelClassNames?: string;
    formControlClassName?: string;
  }
> = (props) => {
  const [field, meta] = useField({ name: props.name });

  const handleChange = (event: any) => {
    field.onChange(event);

    if (props.onChange) {
      props.onChange(event);
    }
  };

  const handleBlur = (event: any) => {
    field.onBlur(event);

    if (props.onBlur) {
      props.onBlur(event);
    }
  };

  return (
    <FormItem
      {...props.formItemProps}
      label={props.label}
      for={props.name}
      form={props.form}
      name={props.name}
      labelClassNames={props.labelClassNames}
      formControlClassName={props.formControlClassName}
    >
      <Datepicker
        {...props}
        id={props.name}
        value={meta.value}
        disabled={props.readonly}
        onChange={handleChange}
        onBlur={handleBlur}
        showIcon={true}
        showWeek={true}
      />
    </FormItem>
  );
};

export default FormCalendar;
